import type {
  GetDocumentByPathQuery,
  GetDocumentByPathQueryVariables,
  GetDocumentHistoryQuery,
  GetDocumentHistoryQueryVariables,
  GetDocumentQuery,
  GetDocumentQueryVariables,
} from '#src/graphql/generated';
import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

export const GET_DOCUMENT: TypedDocumentNode<
  GetDocumentQuery,
  GetDocumentQueryVariables
> = gql`
  query GetDocument($id: String!) {
    document(id: $id) {
      __typename
      ... on Document {
        id
        path
        userId
        context
        value
        format
        formatValidation
        createdAt
        updatedAt
        documentHistory {
          id
          value
          documentId
          createdAt
        }
      }
      ... on DocumentNotFound {
        requestedPath: path
      }
    }
  }
`;

export const GET_DOCUMENT_BY_PATH: TypedDocumentNode<
  GetDocumentByPathQuery,
  GetDocumentByPathQueryVariables
> = gql`
  query GetDocumentByPath($path: String!) {
    documentByPath(path: $path) {
      __typename
      ... on Document {
        id
        path
        userId
        context
        value
        format
        formatValidation
        createdAt
        updatedAt
        documentHistory {
          id
          value
          documentId
          createdAt
        }
        children(input: { limit: 100 }) {
          items {
            id
            path
          }
          pagination {
            hasMore
          }
        }
      }
      ... on DocumentNotFound {
        requestedPath: path
        parent {
          id
          path
        }
        children(input: { limit: 100 }) {
          items {
            id
            path
          }
          pagination {
            hasMore
          }
        }
      }
    }
  }
`;

export const GET_DOCUMENT_HISTORY: TypedDocumentNode<
  GetDocumentHistoryQuery,
  GetDocumentHistoryQueryVariables
> = gql`
  query GetDocumentHistory($id: String!) {
    documentHistory(id: $id) {
      id
      value
      documentId
      createdAt
    }
  }
`;
